import React from 'react';
import PropTypes from 'prop-types';
import { designSystem } from '@yola/ws-ui';

const { ControlGroup, InputGroupField } = designSystem;
const defaultRules = {};

const InputField = ({
  name,
  placeholder,
  title = '',
  description = '',
  iconGlyph = null,
  control,
  rules = defaultRules,
}) => (
  <ControlGroup required title={title} description={description}>
    <InputGroupField
      control={control}
      name={name}
      rules={rules}
      placeholder={placeholder}
      iconGlyph={iconGlyph}
    />
  </ControlGroup>
);

InputField.propTypes = {
  name: PropTypes.string.isRequired,
  placeholder: PropTypes.string.isRequired,
  title: PropTypes.string,
  description: PropTypes.string,
  iconGlyph: PropTypes.oneOfType([PropTypes.string, PropTypes.oneOf([null])]),
  control: PropTypes.shape({}).isRequired,
  rules: PropTypes.shape({}),
};

export default InputField;
